import { Component, OnInit, inject } from '@angular/core';
import { VehicleMaintenance } from '../models/vehicle-maintenance';
import { VehicleService } from '../services/vehicle.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ReceiptService } from '../services/receipt.service';
import { faReceipt, faStickyNote } from '@fortawesome/free-solid-svg-icons';
import { DecimalPipe, DatePipe } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-share',
    templateUrl: './share.component.html',
    styleUrl: './share.component.css',
    imports: [RouterLink, FaIconComponent, NgbPopover, DecimalPipe, DatePipe]
})
export class ShareComponent implements OnInit {

  vehicleMaintenance: VehicleMaintenance | undefined;
  faReceipt = faReceipt;
  faStickyNote = faStickyNote;
  
  private vehicleService = inject(VehicleService);
  private route = inject(ActivatedRoute);
  private receiptService = inject(ReceiptService);

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.vehicleService.getWithMaintenanceShared(params['vehicleId']).subscribe(vehicleMaintenance => {
        this.vehicleMaintenance = vehicleMaintenance;
      });
    });
  }

  downloadReceipt(name: string) {
    this.receiptService.downloadShared(name, this.vehicleMaintenance!.userId, this.vehicleMaintenance!.id)
      .subscribe(authorization => window.open(authorization.url, '_blank'));
  }

}
